import Common from '../common.js';

export default {
    getDictionary: function (className, async, successCallback, failCallback) {
        var result;
        $.ajax({
            url: Application.getBasePath() + '/platform/api/dictionary/' + className,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                result = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');

                try {
                    if (failCallback != null) {
                        failCallback();
                    }
                }
                catch (e) {
                }
                
            }
        });

        return result;
    }
};


// WEBPACK FOOTER //
// ./src/api/dictionary.js